module.exports = __webpack_public_path__ + "static/img/2.9480277.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/2/zh/2.png
// module id = eLnY
// module chunks = 0